<template>
  <v-card>
    <v-toolbar class="teal white--text">
      <v-toolbar-title>{{ $t('profile.password.title') }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon class="white--text" @click="save">
        <v-icon>check</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text style="position: relative">
      <v-alert dismissible transition="fade-transition" success :value="saved" style="position: absolute; left: 0px; top: 0px; width: 100%; z-index: 1">
        {{ $t('profile.password.saved') }}
      </v-alert>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="$t('profile.password.originalPassword')"
              type="password"
              v-model="original"
              :rules="[rules.original]"
            />
          </v-flex>
          <v-flex xs12>
            <password-input
              ref="first"
              v-model="passwords.updated"
              :options="{}"
              :label="$t('profile.password.newPassword')"
              :model="passwords"
            />
          </v-flex>
          <v-flex xs12>
            <password-input
              ref="second"
              v-model="passwords.updated2"
              :options="{ otherPassword: 'updated' }"
              :label="$t('profile.password.newPasswordAgain')"
              :model="passwords"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import User from '@/models/User'
import PasswordInput from '@/components/PasswordInput'

export default {
  props: ['value'],
  data () {
    let self = this
    return {
      saved: false,
      original: null,
      passwords: {
        updated: null,
        udpated2: null
      },
      rules: {
        original (value) {
          return value && value.length > 0 && value !== self.$store.auth.password
            ? self.$t('profile.password.wrongOriginalPassword') : true
        }
      }
    }
  },
  methods: {
    save () {
      if (this.original !== this.$store.auth.password) {
        alert(this.$t('profile.password.wrongOriginalPassword'))
        return
      }
      if (this.passwords.updated !== this.passwords.updated2) return
      if (!this.$refs.first.isValid() || !this.$refs.second.isValid()) return

      User.setPassword({
        password: this.passwords.updated
      })
        .then(() => {
          this.$store.auth.password = this.passwords.updated

          this.original = null
          this.passwords.updated = null
          this.passwords.updated2 = null

          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 3000)
        }).catch(error => {
          console.error(error)
          alert(this.$t('savingFailed'))
        })
    }
  },
  components: {
    PasswordInput
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Password.vue?0ea06b78